<template>
    <div class="list-page">
        <!-- 页头 -->
        <header class="list-head">
            <div class="head-orn">✿</div>
            <h1 class="head-title">信 箱</h1>
            <div class="head-sub">共 {{ listData.length }} 封 · 每一封都值得慢慢读</div>
        </header>

        <!-- 加载中 -->
        <div class="list-loading" v-if="loading">
            <span class="dot"></span><span class="dot"></span><span class="dot"></span>
        </div>

        <!-- 列表 -->
        <div class="list-items" v-else>
            <div
                class="list-item"
                :class="{ special: item.special, fight: item.fight }"
                v-for="(item, index) in listData"
                :key="item.key"
                :style="{ animationDelay: 0.1 + index * 0.1 + 's' }"
                @click="handleView(item.path)"
            >
                <div class="item-tag" v-if="item.tag">{{ item.tag }}</div>
                <h2 class="item-title">{{ item.title }}</h2>
                <p class="item-description">{{ item.description }}</p>
                <div class="item-meta">
                    <span class="publish-time">🕐 {{ item.publishTime }}</span>
                    <span class="read-more">阅读全文 ›</span>
                </div>
            </div>
        </div>

        <!-- 提示：内容来自后台，拉取失败时用内置文案兜底 -->
        <div class="list-foot">
            <span v-if="loadFailed" class="foot-warn">· 内容服务未连接（{{ loadError }}），正在展示内置文案 ·</span>
            <span class="foot-link" @click="handleView('/rose')">🌹 红玫瑰（点击绽放版）</span>
        </div>
    </div>
</template>

<script>
import { publicApi } from '../admin/api';

/** 内置文案兜底：后端没起来时也能看到列表 */
const FALLBACK = [
    {
        key: 'fb-rose',
        title: '张玲，这束红玫瑰是给你的',
        description: '一束红玫瑰，两行旧词：只愿君心似我心，定不负相思意。花开在窗前，话都留在花里',
        publishTime: '2026-09-29',
        path: '/rose',
        tag: '🌹 红玫瑰',
        special: true
    },
    {
        key: 'fb-we',
        title: '入目无他人，四下皆是你',
        description:
            '你迟到了很多年，可我依然为你的到来而高兴。能给你的东西实在不多，这辈子只想把最单纯的喜欢和数不尽的温柔都给你',
        publishTime: '2026-03-01',
        path: '/we'
    },
    {
        key: 'fb-last',
        title: '情不知其所起，一往而情深，有些人光是遇到，就已经是上上签了',
        description:
            '情不知其所起，一往而情深，有些人光是遇到，就已经是上上签了，如果爱上一个不能在一起的人请不要纠缠，不要伤害，不要跟他闹',
        publishTime: '2026-03-10',
        path: '/last'
    },
    {
        key: 'fb-ll',
        title: '感恩命运，让我遇见了你',
        description:
            '感恩命运，让我遇见了你。 第一次见你，听你的声音，我就知道是你了。不是那种轰轰烈烈的确认，而是心里某个地方，轻轻地，被敲了一下',
        publishTime: '2026-03-15',
        path: '/ll'
    },
    {
        key: 'fb-zl',
        title: '有些遇见，从一开始就注定是遗憾',
        description:
            '有些遇见，从一开始就注定是遗憾。就像一场突如其来的雨，你撑着伞出现，陪我走了一段路，可走到路口，你轻轻说了一句再见，便转身消失在人海。',
        publishTime: '2026-06-01',
        path: '/zl'
    }
];

/** 发泄小游戏：手写页面，不随后台内容走 */
const GAME_CARD = {
    key: 'game-beat',
    title: '气不顺？这儿有个沙包，随便打',
    description:
        '点一下屏幕就是一拳。连招不断，家伙还会自己升级——拳头、拖鞋、平底锅、榴莲、大铁锤，最后直接上火箭筒。不心疼，他皮实',
    publishTime: '2026-09-29',
    path: '/beat',
    tag: '🥊 发泄小游戏',
    fight: true
};

function shortDate(s) {
    if (!s) return '';
    const m = String(s).match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
    if (!m) return String(s).slice(0, 10);
    return m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2);
}

export default {
    name: 'ListPage',
    data() {
        return {
            loading: true,
            loadFailed: false,
            loadError: '',
            remote: []
        };
    },
    computed: {
        listData() {
            const letters = (this.remote.length ? this.remote : FALLBACK).slice();
            return letters.concat([GAME_CARD]);
        }
    },
    created() {
        this.fetchPages();
    },
    methods: {
        fetchPages() {
            publicApi
                .pages()
                .then(data => {
                    const items = (data && data.items) || [];
                    this.remote = items
                        .map(it => ({
                            key: 'page-' + it.id,
                            title: it.title,
                            description: it.summary || it.subtitle || '',
                            publishTime: shortDate(it.publishTime || it.updateTime || it.date),
                            path: '/p/' + it.code,
                            tag: it.tag,
                            special: it.theme === 'rose',
                            fight: false
                        }))
                        .filter(it => it.title);
                })
                .catch(err => {
                    this.loadFailed = true;
                    this.loadError = (err && err.message) || '未知错误';
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleView(path) {
            if (!path) return;
            this.$router.push({ path });
        }
    }
};
</script>

<style lang="less" scoped>
.list-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 50px 30px 60px;
    /* 给底部菜单留位，避免最后一张卡片被压住 */
    padding-bottom: calc(170px + constant(safe-area-inset-bottom));
    padding-bottom: calc(170px + env(safe-area-inset-bottom));
    background: linear-gradient(180deg, #fdf3e7 0%, #f9ead8 45%, #f5e2cc 100%);
}

/* ---------- 页头 ---------- */
.list-head {
    text-align: center;
    margin-bottom: 44px;
    .head-orn {
        font-size: 28px;
        color: #d8a48f;
        margin-bottom: 14px;
    }
    .head-title {
        margin: 0;
        font-size: 44px;
        font-weight: 600;
        color: #5b4636;
        letter-spacing: 10px;
    }
    .head-sub {
        margin-top: 14px;
        font-size: 24px;
        color: #b08d6e;
    }
}

/* ---------- 加载 ---------- */
.list-loading {
    padding: 120px 0;
    text-align: center;
    .dot {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin: 0 6px;
        border-radius: 50%;
        background: #d8a48f;
        animation: dotPulse 1s ease-in-out infinite;
        &:nth-child(2) {
            animation-delay: 0.16s;
        }
        &:nth-child(3) {
            animation-delay: 0.32s;
        }
    }
}
@keyframes dotPulse {
    0%,
    100% {
        opacity: 0.3;
        transform: translateY(0);
    }
    50% {
        opacity: 1;
        transform: translateY(-6px);
    }
}

/* ---------- 列表 ---------- */
.list-items {
    max-width: 640px;
    margin: 0 auto;
}

.list-item {
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(176, 141, 110, 0.25);
    border-radius: 16px;
    box-shadow: 0 6px 20px rgba(150, 110, 70, 0.1);
    padding: 30px 30px 24px;
    margin-bottom: 28px;
    cursor: pointer;
    opacity: 0;
    animation: cardIn 0.5s ease forwards;
    transition: box-shadow 0.3s ease, transform 0.3s ease;
    &:active {
        transform: scale(0.98);
    }
}
@keyframes cardIn {
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* 红玫瑰专属卡片 */
.list-item.special {
    background: linear-gradient(180deg, #fff6f6 0%, #ffecef 100%);
    border: 1px solid rgba(207, 31, 61, 0.35);
    box-shadow: 0 8px 26px rgba(160, 20, 45, 0.18);
    .item-title {
        color: #9c1030;
    }
    .item-description {
        color: #a56a76;
    }
    .read-more {
        color: #cf1f3d;
    }
}

/* 发泄小游戏卡片 */
.list-item.fight {
    background: linear-gradient(180deg, #fdf0fa 0%, #f5e2f4 100%);
    border: 1px solid rgba(160, 32, 128, 0.32);
    box-shadow: 0 8px 26px rgba(120, 20, 100, 0.18);
    .item-title {
        color: #7a1a63;
    }
    .item-description {
        color: #8c6a86;
    }
    .read-more {
        color: #b02a8c;
    }
    .item-tag {
        color: #a01a7a;
        background: rgba(160, 26, 122, 0.1);
    }
}
.item-tag {
    display: inline-block;
    margin-bottom: 14px;
    font-size: 20px;
    color: #cf1f3d;
    background: rgba(207, 31, 61, 0.1);
    border-radius: 999px;
    padding: 4px 18px;
}

.item-title {
    margin: 0 0 14px;
    font-size: 32px;
    font-weight: 600;
    color: #5b4636;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.item-description {
    margin: 0 0 20px;
    font-size: 26px;
    color: #8a7a6b;
    line-height: 1.7;
    text-align: justify;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.item-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba(176, 141, 110, 0.2);
    padding-top: 18px;
}

.publish-time {
    font-size: 22px;
    color: #a08a76;
}

.read-more {
    font-size: 24px;
    color: #c69c7b;
}

/* ---------- 页脚 ---------- */
.list-foot {
    max-width: 640px;
    margin: 10px auto 0;
    text-align: center;
    font-size: 22px;
    color: #b08d6e;
    line-height: 1.8;
    .foot-warn {
        display: block;
        margin-bottom: 10px;
        color: #c98a4b;
    }
    .foot-link {
        display: inline-block;
        padding: 8px 22px;
        color: #a3122e;
        background: rgba(255, 255, 255, 0.7);
        border: 1px solid rgba(207, 31, 61, 0.28);
        border-radius: 999px;
    }
}
</style>
